/** Tailoring for a job the person pasted, with no posting in the catalogue behind it. */

import { postJson } from "../client";
import type { PastedJob } from "@/lib/tools/pastedJob";
import { ENVOY_BASE } from "./base";

/** What envoy keeps of a page's text: `MAX_DESCRIPTION_CHARS` in `models/page.rs`. */
export const MAX_DESCRIPTION_CHARS = 20_000;

/** `envoy_api::assist::TailorRequested`: where the tailor stands once it is asked. */
export interface TailorRequested {
    application_id: string;
    posting_id: string;
    /** `TAILORING`, `NEEDS_YOU`, or `MATCHED` or `FAILED` with `waiting_on`. */
    status: string;
    /** The posting was in the queue and left it, so it goes to the tailor once. */
    unqueued: boolean;
    /** `OUT_OF_TAILORS`, `SLOWED`, `BUSY` or `RETRY_LATER`, when something stops the tailor. */
    waiting_on?: string;
    retry_after?: string;
}

/**
 * Tailors the person's saved resume for a pasted job: its link, title,
 * company and text. A posting from the catalogue is named too, and envoy
 * tailors that one. The resume box's text never goes: the tailor reads
 * the saved one. `fields` is empty, since no form was read.
 */
export function tailorPastedJob(job: PastedJob): Promise<TailorRequested> {
    return postJson(`${ENVOY_BASE}/assist/tailor`, {
        address: job.address,
        ...(job.posting && { posting: job.posting }),
        title: job.title,
        company: job.company,
        description: Array.from(job.description).slice(0, MAX_DESCRIPTION_CHARS).join(""),
        fields: [],
    });
}
